import React, { useEffect, useState } from "react";
import "./customer-relationships.scss";
import { Link } from "react-router-dom";
import { useWindowSize } from "@react-hook/window-size/throttled";
import StrokePattern from "../../../components/stroke-pattern/stroke-pattern";
import { Button } from "@mui/material";
import { BsClockFill } from "react-icons/bs";

const CustomerRelationships = () => {
  const [playerSize, setPlayerSize] = useState("612px");
  const [width, height] = useWindowSize();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="customerRelationships slideUpAnimation initially-hidden animated full-width-element">
      {/* <div className="clippedBackground animated" style={{ backgroundImage: `url('/images/colour-wave.svg')` }}></div> */}

      <div className="problemBox">
        <img src="/images/Dotted-random-pattern.svg" className="dotted-random-pattern" />

        <h1 className="bigHeading">Customer relationships</h1>
        <p className="subtitle2">
          If your business experiences any of these challenges around customer relationship management, the Kzen8 platform can help:
          <br></br>
          <br></br>
        </p>
        <div className="challengeContainer">
          <div className={`challengeBox primary body ${width > 475 ? "floatUpAnimation" : ""} animated delay-1-half`} style={{ marginLeft: "20%" }}>
            Opportunities are missed because your team has no easy way of properly capturing details of new leads.
          </div>

          <div className={`challengeBox primaryG body ${width > 475 ? "floatUpAnimation" : ""} animated  delay-1-quarter`} style={{ marginRight: "30%" }}>
            It is difficult for your team to stay on top of where leads and prospects are at and know which ones need to be contacted.<br></br>
          </div>

          <div className={`challengeBox secondary body ${width > 475 ? "floatUpAnimation" : ""} animated delay-1`} style={{ marginRight: "35%" }}>
            You don’t have the information you need to easily identify which sales and marketing activities are wasting your time and money.<br></br>
          </div>

          <div className={`challengeBox tertiary body ${width > 475 ? "floatUpAnimation" : ""} animated`}>
            You have looked at off-the-shelf CRM solutions but cannot find one that is easy to use and actually does what you want it to do.<br></br>
          </div>
          <div className="background">
            <img src="/images/Stressed.webp" style={{ height: playerSize }} />
            {/* <lottie-player src="/lottie-files/challenge.json" background="transparent" speed="1" style={{ width: playerSize, height: playerSize }} autoplay loop></lottie-player> */}
          </div>
        </div>
      </div>

      <div className="solutionBox cardShadow">
        <section className="left">
          <StrokePattern styles={{ position: 'absolute', width: '200px', left: '-100px' }} />
          <h1 className="header">How we can help</h1>
          <p className="subtitle2">
            All solutions developed using the Kzen8 platform are completely bespoke to each business, but here is a short demo showing some features that a Kzen8 solution for customer relationship management could include:
          </p>

          <Link to="/contact-us">
            <Button variant="contained" className="btn btn-secondary subtitle2 callToAction" endIcon={<BsClockFill />}>Schedule a demo</Button>
          </Link>
        </section>

        <section className="right">
          <iframe
            width={Math.max(width / 1.75, 320)}
            height={Math.max(width / 3.15, 200)}
            src="https://www.youtube.com/embed/SQQf1uj8Jao"
            title="YouTube video player"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen={true}
          ></iframe>
          <img src="/images/Dotted pattern.svg" className="dotted-pattern" />

        </section>
      </div>
    </div>
  );
};

export default CustomerRelationships;
